import type {Result, UseCase} from 'framework';
import type {WorkoutError} from '../../domain/errors';
import type {Workout} from '../../domain/workout';
import type {WorkoutId} from '../../domain/workout-id.value-object';
import type {WorkoutRepository} from '../ports/workout.repository';

export type GetWorkoutInput = {
  readonly workoutId: WorkoutId;
};

export class GetWorkout implements UseCase<[GetWorkoutInput], Workout> {
  constructor(private readonly repository: WorkoutRepository) {}

  execute(input: GetWorkoutInput): Promise<Result<Workout, WorkoutError>> {
    return this.repository.getWorkout(input.workoutId);
  }
}
